import React, { Component } from 'react';
import classNames from 'classnames/bind';
import styles from './ThoundsSongs.scss';

const cx = classNames.bind(styles);

class ThoundsSongs extends Component {
  render() {
    return (
      <div className={cx('ThoundsSongs')}>
        <div className="close" onClick={this.props.initModal}></div>
        <h6>오케이닥터 1000곡 저작권 리스트</h6>
        <div className="list-content"></div>
      </div>
    );
  }
}

export default ThoundsSongs;
